import React, { useState, useEffect } from 'react';
import SharedHelmet from ".././Helmet";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/ramadan.webp";
import BlinkingText from '../../BlinkingText';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import MainCalculatorsList from '../MainCalculators';
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import moment from 'moment-hijri';
const TITLE = "Countdown to Ramadan 2026 - Remaining Time Until Ramadan 2026";
const DESCRIPTION = "How many days left until Ramadan 2026? The countdown to the blessed month of Ramadan 1447 AH provides you with accurate information about the start date of Ramadan, how many days are left until Ramadan, and the number of days remaining until the arrival of the holy month.";
const KEYWORDS = "Ramadan 2026, How many days until Ramadan 2026, Countdown to Ramadan";
const OG_URL = "https://do-calculate.com/articles-en/ramadan";
function Ramadan() {
    const [ramadanDates, setRamadanDates] = useState([
        { name: 'Ramadan 2026', date: new Date("2026-02-18T00:00:00") },
        { name: 'Ramadan 2027', date: new Date("2027-02-08T00:00:00") },
        { name: 'Ramadan 2028', date: new Date("2028-01-28T00:00:00") },
        { name: 'Ramadan 2029', date: new Date("2029-01-16T00:00:00") }
    ]);
    const nextRamadan = ramadanDates.find(d => d.name === 'Ramadan 2026')?.date || new Date("2026-02-18T00:00:00");
    const dayName = nextRamadan.toLocaleDateString('en-US', { weekday: 'long' });
    useEffect(() => {
        async function fetchRamadanDates() {
            try {
                const datesCol = collection(db, "dates");
                const querySnapshot = await getDocs(datesCol);
                let fetchedRamadan2026Date = null;
                const newRamadanDates = [];
                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    if (data.ramadan) {
                        const date = data.ramadan.toDate ? data.ramadan.toDate() : new Date(data.ramadan);
                        if (date.getFullYear() === 2026) {
                            fetchedRamadan2026Date = date;
                            newRamadanDates.push({ name: 'Ramadan 2026', date: date });
                        }
                    }
                });
                if (fetchedRamadan2026Date) {
                    setRamadanDates(prevDates =>
                        prevDates.map(item =>
                            item.name === 'Ramadan 2026'
                                ? { ...item, date: fetchedRamadan2026Date }
                                : item
                        )
                    );
                } else {
                    console.warn("No Ramadan 2026 date found in DB. Using default.");
                }
            } catch (error) {
                console.error("Error fetching Ramadan dates:", error);
            }
        }
        fetchRamadanDates();
    }, []);
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }
        return timeLeft;
    };
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(nextRamadan));
    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(nextRamadan));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft, nextRamadan]);
    return (
        <div >
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className='p-3 mb-2 bg-success text-white'>
                Countdown to Ramadan 2026
            </h1>
            <div>
                <BlinkingText
                    text={`Countdown to Ramadan: Ramadan month 2026 is expected to start on ${dayName}, ${nextRamadan?.toLocaleDateString('en-GB')} (Gregorian) and ${moment(nextRamadan).format('iDD/iMM/iYYYY')} (Hijri).`}
                />
            </div>
            <div className="row">
                <div id="timer" style={{ width: '100%', fontSize: '40px' }}>
                    <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th className="bmi-header"  >Days</th>
                                <th className="bmi-header" >Hours</th>
                                <th >Minutes</th>
                                <th >Seconds</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td id="days" >{timeLeft.days}</td>
                                <td id="hours">{timeLeft.hours}</td>
                                <td id="minutes" >{timeLeft.minutes}</td>
                                <td id="seconds" >{timeLeft.seconds}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div>
                        <h2 className='p-3 mb-2 bg-success text-white' style={{ color: '#333', fontSize: '36px', textAlign: 'center' }}>Upcoming Ramadan Dates</h2>
                        <table style={{ fontSize: '24px', width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '2px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f2f2f2' }}>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Ramadan Date</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Date</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Remaining</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ramadanDates.map((ramadan, index) => (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                        <td style={{ padding: '12px' }}>{ramadan.name}</td>
                                        <td style={{ padding: '12px' }}>{ramadan.date.toLocaleDateString('en-GB')}</td>
                                        <td style={{ padding: '12px' }}>{calculateTimeLeft(ramadan.date).days} Days</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-sm-4 col-md-4">
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.TimeArticles_En}></MainCalculatorsList>
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className='p-3 mb-2 bg-success text-white'>Countdown to Ramadan 2026</h3>
                    <p>
                        In this article, we provide you with a detailed countdown to the blessed month of Ramadan, so you can stay informed about how many days are left until the arrival of this noble month. Many of us wonder how much time is left until the blessed month of Ramadan. Therefore, in this article, we present to you the countdown to the blessed month of Ramadan, allowing you to know how much time is left until Ramadan, how many days are left, and when Ramadan is. Watch the countdown to Ramadan at the top of this article.
                    </p>
                    <p>
                        According to the <a href='/calculator/en/gregorian_to_hijri/'>Date Converter</a> website, Ramadan 2026 will begin on {dayName}, {nextRamadan?.toLocaleDateString('en-GB')} AD, and {moment(nextRamadan).format('iDD/iMM/iYYYY')} AH. You can view the countdown to Ramadan 2026 in this article.
                    </p>
                    <p>
                        Here you will find the countdown to Ramadan, allowing you to know how many days are left until the holy month of Ramadan.
                    </p>
                    <hr />
                    <RelatedLinks />
                    <hr />
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        Calculate Remaining Days until the Holy Month of Ramadan
                    </h3>
                    <p>
                        Through the Ramadan Countdown program, you can know how many days are left until Ramadan in both the Gregorian and Hijri calendars. You can also find out how many days are left until Ramadan, and how many days are left until the end of Ramadan, and when Ramadan begins. Watch the countdown to the holy month of Ramadan above.
                    </p>
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        Ramadan
                    </h3>
                    <p>
                        Ramadan, the ninth month in the Hijri calendar, immediately follows the month of Sha'ban and is distinguished by its special status in the hearts of Muslims. It is the month of fasting, one of the pillars of Islam, during which Muslims refrain from food, drink, and desires from dawn until sunset. The month of Ramadan begins with the sighting of the crescent moon on the 29th day of Sha'ban, and if the crescent moon is not sighted, Sha'ban will be 30 days and the next day will be the first day of Ramadan. The number of days in the month of Ramadan ranges from 29 to 30 days, depending on the sighting of the crescent moon.
                    </p>
                    <p>
                        Muslims celebrate Eid al-Fitr at the end of Ramadan, and Ramadan holds a special place in Islamic history and heritage, as the Quran was revealed during the Night of Decree in this noble month. The descent of revelation upon the Prophet Muhammad at various times during this month is a testimony to his greatness and his message.
                    </p>
                    <div>
                        <br />
                        <img src={imageUrl} alt="Countdown to Ramadan" style={{ width: '100%', height: 'auto' }} />
                        <br />
                    </div>
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        Benefits of Fasting in the Month of Ramadan
                    </h3>
                    <p>
                        Fasting in the month of Ramadan has many benefits for the fasting person, encompassing all physical and psychological aspects. If the fasting person follows a healthy diet, fasting will have many positive effects on the fasting person's health. These numerous benefits include improving blood levels, reducing harmful lipid levels in the blood, regulating blood pressure, maintaining blood sugar levels, reducing stress and anxiety, and combating cancer and inflammation. In this article, we will mention the numerous benefits of fasting in the blessed month of Ramadan.
                    </p>
                    <ul>
                        <li>Improving blood levels</li>
                        <li>Reducing harmful lipid levels in the blood</li>
                        <li>Regulating blood pressure</li>
                        <li>Maintaining blood sugar levels</li>
                        <li>Combating cancer and inflammation</li>
                        <li>Improving digestion and the digestive system</li>
                        <li>Enhancing mental and cognitive functions</li>
                    </ul>
                </div>
                <br />
            </div>
        </div>
    );
}
export default Ramadan;